import { render, staticRenderFns } from "./BriefListEntry.vue?vue&type=template&id=41b9f0b4&scoped=true"
import script from "./BriefListEntry.vue?vue&type=script&lang=js"
export * from "./BriefListEntry.vue?vue&type=script&lang=js"
import style0 from "./BriefListEntry.vue?vue&type=style&index=0&id=41b9f0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9f0b4",
  null
  
)

export default component.exports